import { reactive, readonly, watch } from 'vue';
import { useComputedCallback } from './useComputedCallback';
import { pick } from './pick';
const useReducer = (reducer, initialState) => {
    const state = reactive(initialState);
    const dispatch = (...arg) => {
        reducer(state, ...arg);
    };
    return [readonly(state), dispatch];
};
export const useRouter = (historyValue) => {
    const history = useComputedCallback(historyValue);
    const [state, dispatch] = useReducer((state, { action, location }) => {
        state.action = action;
        state.location = location;
    }, pick(history.value, ['action', 'location']));
    watch(history, (history, _, onCleanup) => {
        const unlisten = history.listen(dispatch);
        onCleanup(unlisten);
    }, {
        flush: 'sync',
        immediate: true,
    });
    return state;
};
